<template>
  <div class="user-info">
    <!-- 修改密码 -->
    <vxe-modal
        v-model="isShowModal"
        width="600"
        height="330"
        title="重置支付密码"
        destroy-on-close
    >
      <p slot="header" class="box-tit-211130">
        <span>重置支付密码</span>
      </p>
      <vxe-form
          ref="xForm"
          title-align="right"
          title-width="160"
          :data="formData"
          :rules="formRules"
          style="margin-top: 20px; padding-right: 50px"
          @submit="submitEvent"
      >
        <vxe-form-item title="注册手机号" field="regisiterNum" span="24">
          <template v-slot="scope">
            <vxe-input
                v-model="formData.regisiterNum"
                disabled
                placeholder="请输入手机号"
                @input="$refs.xForm.updateStatus(scope)"
                style="width: 400px"
            ></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="重置支付密码" field="password" span="24">
          <template v-slot="scope">
            <vxe-input
                v-model="formData.password"
                type="password"
                placeholder="密码长度不少于8个字符"
                @input="$refs.xForm.updateStatus(scope)"
                style="width: 400px"
            ></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="确认密码" field="newPassword" span="24">
          <template v-slot="scope">
            <vxe-input
                type="password"
                v-model="formData.newPassword"
                placeholder="再次输入支付密码"
                @input="$refs.xForm.updateStatus(scope)"
                style="width: 400px"
            ></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item align="right" span="24" style="margin-top: 20px">
          <vxe-button
              status="primary"
              style="width: 140px; border-radius: 0px"
              @click="cancelSubmit"
          >取消
          </vxe-button>
          <vxe-button
              type="submit"
              status="primary"
              style="width: 140px; border-radius: 0px"
          >保存
          </vxe-button>
        </vxe-form-item>
      </vxe-form>
    </vxe-modal>
  </div>
</template>

<script>

import {apiPost} from "@/utils/api";
import {showLoading, hideLoading} from "@/utils/util";
import md5 from 'js-md5'

export default {
  name: 'EditUserPayPassword',
  data() {
    const newPwdValid = ({cellValue}) => {
      if (
          this.formData.newPassword !== null &&
          this.formData.newPassword !== ""
      ) {
        if (this.formData.newPassword !== this.formData.password) {
          return Promise.reject(new Error("两次输入密码不一致"));
        }
      }
    };
    const regNumber = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,18}$/;
    const pwdValid = ({cellValue}) => {
      if (!regNumber.test(this.formData.newPassword)) {
        return Promise.reject(
            new Error("密码长度由8-18位字母和数字组成")
        );
      }
    };
    return {
      isShowModal: false,
      formData: {
        newPassword: null,
        confirmPassword: null,
      },
      formRules: {
        newPassword: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {validator: pwdValid}
        ],
        confirmPassword: [{required: true, validator: newPwdValid}],
      },
      isTrue: false,
    };
  },
  methods: {
    showModal(regisiterNum, userSignId) {
      this.userSignId = userSignId
      this.isShowModal = true;
      this.formData = {
        regisiterNum: regisiterNum,
        newPassword: null,
        confirmPassword: null,
      };
      if (undefined != this.$refs.xForm) {
        this.$refs.xForm.clearValidate();
      }
    },
    async fullValidEvent() {
      const errMap = await this.$refs.xForm
          .validate()
          .catch((errMap) => errMap);
      if (!errMap) {
        this.submitEvent();
      }
    },
    async submitEvent() {
      if (this.formData.newPassword !== this.formData.password) {
        this.$XModal.alert({
          message: "两次输入密码不一致",
          status: "error",
        });
        return
      }

      let param = {
        userId: this.userSignId,
        newPassword: md5(this.formData.newPassword)
      }
      showLoading()
      let res = await apiPost('api/auth/', 'baseUserSign/updateDrawPassword', param);
      hideLoading()
      if (res.status == 1) {
        this.$Message.success("操作成功")
        this.isShowModal = false;
      } else {
        this.$Message.error(res.message)
      }
    },
    cancelSubmit() {
      this.isShowModal = false;
    },
  },
};
</script>

<style>
.user-info {
  float: right;
  color: #333;
}

.user-info .name {
  cursor: pointer;
}

.user-info .name em {
  padding: 0 5px 0 10px;
}

.log-out {
  font-size: 18px;
  display: inline-block;
  padding: 0 20px;
}

.log-out:hover {
  background: rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

.ivu-layout-header .vxe-modal--header {
  line-height: 1.5;
}

.top-change-pwd .vxe-input .vxe-input--suffix,
.top-change-pwd .vxe-input .vxe-input--extra-suffix {
  top: 15px !important;
}

@media screen and (max-width: 750px) {
}
</style>